import { isClientBoard } from '../../../../functions/client-model/client-board/is-client-board';
import { isLeafNode } from '../../../../functions/client-model/client-node/is-leaf-node';
import { ClientNode } from '../../../../model/client-model/client-node';
import { ClientBoardContainer } from '../../../../public/dashboard/shared/model/client-board-container';
import { getLeafNodes } from '../../functions/get-leaf-nodes';
import { getCalculationResultId } from '../dashboard-calculation/get-calculation-result-id';

export function getLeafNodeCalculationResultIds(
  node: ClientNode | ClientBoardContainer,
  board: ClientBoardContainer
): string[] {
  const leafNodes = isClientBoard(node) ? getLeafNodes(node) : isLeafNode(node) ? [node] : getLeafNodes(board, node);
  return leafNodes.reduce((ids: string[], node: ClientNode) => {
    const id = getCalculationResultId(node);
    if (id) {
      ids.push(id);
    }
    return ids;
  }, []);
}
